import { UseGetProductResponse } from "types/queries";

import { trackPdcEvent } from "./track-pdc-event";

export const trackModerationFailureEvent = (
  product: UseGetProductResponse,
  formTrackingId: string,
  fieldName: string,
  step: string | number,
  subStep: string | number
) => {
  trackPdcEvent(
    product,
    `${formTrackingId}:${fieldName}`,
    "moderation_failure",
    step,
    subStep
  );
};
